import bwip from 'bwip-js';

const moduleWidth = 5; // enough scale, means 5px/1mm

export const getCanvas = (text, options) => {
  const bwipOptions = {
    ...options,
    bcid: options.codeType,
    text: text,
    scale: moduleWidth
  };

  additionalValidation(text, options.codeType);

  if (bwipOptions.barratio) {
    bwipOptions.spaceratio = bwipOptions.barratio;
  }

  if (bwipOptions.codeType === 'qrcode' || bwipOptions.codeType === 'datamatrix') {

  } else {
      bwipOptions.inkspread  = 0.2; // reduce bar width to space
      bwipOptions.height = 14; // in mm // height(22) - textsize(10) - paddingheight(3)*2
  }

  if (!bwipOptions.backgroundcolor) {
    delete bwipOptions.backgroundcolor;
  }

  // available color format: 'RRGGBB[AA]'
  ['backgroundcolor', 'barcolor', 'textcolor'].forEach(prop => {
    if (bwipOptions[prop]) {
      bwipOptions[prop] = bwipOptions[prop].toUpperCase();
      if (bwipOptions[prop][0] === '#') {
        bwipOptions[prop] = bwipOptions[prop].slice(1);
      }
    }
  });

  delete bwipOptions.codeType;
  delete bwipOptions.codeGroup;

  const canvas = document.createElement('canvas');
  bwip.toCanvas(canvas, bwipOptions);
  return canvas;
};

const additionalValidation = (text, codeType) => {
  if (
    (codeType === 'code39' ||
      codeType === 'code128' ||
      codeType === 'interleaved2of5') &&
    text.length > 48
  ) {
    throw new Error(`:this code must contain 48 characters or less`);
  }
};
